<div id="calendar" class="page-layout simple fullwidth">

  <dataset-calendar-header-view
    (viewDateChange)='onViewDateChanged($event)'
    (addClicked)='onAdd()'
  ></dataset-calendar-header-view>

  @if (datasetACS.loading.value) {
    <div class='mx-24'>
      <mat-progress-bar  color="accent" mode="indeterminate"></mat-progress-bar>
    </div>
  }

  <!-- EVENT TITLE TEMPLATES -->
  <ng-template #customEventTitleTemplate let-day="day" let-event='event' let-locale="locale">
    @switch (_calendarService.calendarConfig.templateCodes.eventTitleTemplate) {
      @case ("simple-text") {
        <span class='ml-4 h4'>
          @switch (event.type) {
            @case ("trip_resource_staff_assignments") {
              @if (event.meta.fullName) {
                <span>{{event.meta.fullName}}</span>
              }
            }
            @case ("trip_resource_allotments") {
              @if (event.meta.resource_allotment && event.meta.resource_allotment.quantity >= 0) {
                <span>
                  [{{event.meta.resource_allotment.quantity}}]
                </span>
              }
            }
            @default {
              <span>{{event.title || "Evento"}}</span>
            }
          }
        </span>
      }
      @default {
        <span style='display:none;'>TEMPLATE customEventTitleTemplate missed for {{_calendarService.calendarConfig.templateCodes.eventTitleTemplate}}</span>
      }
    }
  </ng-template>
  <!-- / EVENT TITLE TEMPLATES -->

  <!-- EVENT ACTIONS TEMPLATES -->
  <ng-template #customEventActionsTemplate let-event='event'>
    @switch (_calendarService.calendarConfig.templateCodes.eventActionsTemplate) {
      @case ("default_actions") {
        <span class="cal-event-actions">
          @for (eventAction of event.actions; track eventAction) {
            @if (eventAction.routerLink) {
              <a
                [routerLink]="eventAction.routerLink"
                mat-icon-button
                [ngClass]="eventAction.cssClass"
                class="cal-event-action"
                >
                <mat-icon>{{ eventAction.icon }}</mat-icon>
              </a>
            }
            @if (!eventAction.routerLink) {
              <button
                mat-icon-button
                [color]='eventAction.color'
                [ngClass]="eventAction.cssClass"
                class="cal-event-action"
                (click)="eventAction.onClick({ event: event, component: this })"
                >
                <mat-icon>{{ eventAction.icon }}</mat-icon>
              </button>
            }
          }
        </span>
      }
      @case ("no-actions") {
        <span class="cal-event-actions"></span>
      }
      @default {
        <span style='display:none;'>TEMPLATE customEventActionsTemplate missed for {{_calendarService.calendarConfig.templateCodes.eventTitleTemplate}}</span>
      }
    }
  </ng-template>
  <!-- /EVENT ACTIONS TEMPLATES -->
  <ng-template #emptyTemplate></ng-template>

  <!-- CELL TEMPLATES -->
  <ng-template
    #customMonthCellTemplate
    let-day="day"
    let-openDay="openDay"
    let-locale="locale"
    let-tooltipPlacement="tooltipPlacement"
    let-highlightDay="highlightDay"
    let-unhighlightDay="unhighlightDay"
    let-eventClicked="eventClicked"
    let-tooltipTemplate="tooltipTemplate"
    let-tooltipAppendToBody="tooltipAppendToBody"
    let-trackByEventId="trackByEventId"
    let-validateDrag="validateDrag"
    >
    @switch (_calendarService.calendarConfig.templateCodes.monthCellTemplate) {
      @case ("text") {
        <div class="cal-cell-top">
          <span class="cal-day-number">{{ day.date | calendarDate: 'monthViewDayNumber':locale}}</span>
        </div>
        @if (day.events.length > 0) {
          <div class="cal-events">
            @for (event of day.events; track $index) {
              <div (mwlClick)="eventClicked.emit({ event: event })" (mouseenter)="highlightDay.emit({ event: event })" (mouseleave)="unhighlightDay.emit({ event: event })" [ngClass]="$safeNavigationMigration(event?.cssClass)" class="cal-event-container fx-column fx-justify-center fx-items-center">
                @switch (event.type) {
                  @case ("trip_resource_staff_assignments") {
                    @if (event.meta.description) {
                      <span class='single-line'>{{event.meta.description}}</span>
                    }
                    @if (!event.meta.description) {
                      <span class='single-line'>{{event.title || "Evento"}}</span>
                    }
                  }
                  @case ("trip_resource_allotments") {
                    @if (event.meta.resource_allotment && event.meta.resource_allotment.quantity >= 0) {
                      <span>
                        [{{event.meta.resource_allotment.quantity}}]
                      </span>
                    }
                  }
                  @default {
                    <span>{{event.title || "Evento"}}</span>
                  }
                }
              </div>
            }
          </div>
        }
      }
      @default {
        <span style='display:none;'>TEMPLATE customMonthCellTemplate missed for {{_calendarService.calendarConfig.templateCodes.monthCellTemplate}}</span>
      }
    }
  </ng-template>
  <!-- / CELL TEMPLATES 	-->

  <!-- CONTENT -->
  <div class="content" fusePerfectScrollbar [@animate]="{value:'*',params:{delay:'200ms',y:'50px'}}">
    <div>
      @switch (_calendarService.view) {
        @case ('month') {
          <mwl-calendar-month-view
            [viewDate]="_calendarService.viewDate"
            [events]="events"
            [refresh]="datasetACS.loading"
            [activeDayIsOpen]="activeDayIsOpen"
            [eventTitleTemplate]='_calendarService.calendarConfig.templateCodes.eventTitleTemplate && customEventTitleTemplate'
            [eventActionsTemplate]='_calendarService.calendarConfig.templateCodes.eventActionsTemplate && customEventActionsTemplate'
            [cellTemplate]='_calendarService.calendarConfig.templateCodes.monthCellTemplate && customMonthCellTemplate'
            [openDayEventsTemplate]='_calendarService.calendarConfig.templateCodes.monthOpenDayEventsTemplate && emptyTemplate'
            (dayClicked)="dayClicked($event.day)"
            (eventClicked)="eventClick($event.event)"
            (eventTimesChanged)="eventTimesChanged($event)"
            (beforeViewRender)="beforeMonthViewRender($event)">
          </mwl-calendar-month-view>
        }
        @case ('week') {
          <mwl-calendar-week-view
            [eventTitleTemplate]='_calendarService.calendarConfig.templateCodes.eventTitleTemplate && customEventTitleTemplate'
            [eventActionsTemplate]='_calendarService.calendarConfig.templateCodes.eventActionsTemplate && customEventActionsTemplate'
            [viewDate]="_calendarService.viewDate"
            (viewDateChange)="onViewDateChanged($event)"
            [events]="events"
            [refresh]="datasetACS.loading"
            (dayClicked)="dayClicked($event.day)"
            (eventClicked)="eventClick($event.event)"
            (eventTimesChanged)="eventTimesChanged($event)">
          </mwl-calendar-week-view>
        }
        @case ('day') {
          <mwl-calendar-day-view
            [viewDate]="_calendarService.viewDate"
            [eventTitleTemplate]='_calendarService.calendarConfig.templateCodes.eventTitleTemplate && customEventTitleTemplate'
            [eventActionsTemplate]='_calendarService.calendarConfig.templateCodes.eventActionsTemplate && customEventActionsTemplate'
            (viewDateChange)="onViewDateChanged($event)"
            [events]="events"
            [refresh]="datasetACS.loading"
            (dayClicked)="dayClicked($event.day)"
            (eventClicked)="eventClick($event.event)"
            (eventTimesChanged)="eventTimesChanged($event)">
          </mwl-calendar-day-view>
        }
      }
    </div>
  </div>
  <!-- / CONTENT -->
</div>
